module.exports = __webpack_public_path__ + "media/reju2.66acd683.mp4";